import React from "react";
import { Card, CardContent, Checkbox, Box, Divider } from "@mui/material";
import Label from "../../../../components/Label/Label";

const RuleSelector = ({
  selectedRules,
  setSelectedRules,
  ruleOptions,
  disabled,
}) => {
  const handleChange = (key, checked) => {
    const updated = checked
      ? [...selectedRules, key]
      : selectedRules.filter((r) => r !== key);
    setSelectedRules(updated);
  };

  return (
    <Card elevation={0} sx={{ backgroundColor: "#fff" }}>
      <CardContent sx={{ p: 0.5 }}>
        {ruleOptions.map((rule, index) => (
          <Box key={rule.key} mb={0.2}>
            <Box display="flex" alignItems="flex-start">
              <Checkbox
                size="small"
                checked={selectedRules.includes(rule.key)}
                onChange={(e) => handleChange(rule.key, e.target.checked)}
                sx={{ p: 0.5 }}
                disabled={disabled || index === 0}
              />
              <Box>
                <Label text={rule.label} fontSize="13px" fontWeight="500" />
                <Label text={rule.description} color="#888" fontSize="10px" />
              </Box>
            </Box>
            {index !== ruleOptions.length - 1 && (
              <Divider sx={{ my: 0.4 }} />
            )}{" "}
          </Box>
        ))}
      </CardContent>
    </Card>
  );
};

export default RuleSelector;
